/**
 * Space (px) the grid host may occupy inside a height-capped ancestor.
 *
 * The old measure used `[data-od-table-pane].bottom - host.top`. That pane is
 * often `h-min` (content-sized), so the "cap" tracked the host itself and a
 * ResizeObserver feedback loop raised height by ~1px per frame when growing
 * (search clear, larger page size). Only absolute max-height ancestors are a
 * real bound (e.g. overview `max-h-[420px]`). Percentage max-heights and
 * uncapped collection pages return null so hug height wins and the page
 * scrolls.
 */
export function measureGridHostCap(host: HTMLElement): number | null {
  let el: HTMLElement | null = host.parentElement;
  while (el && el !== document.body) {
    const maxHeight = getComputedStyle(el).maxHeight;
    if (maxHeight !== "none" && maxHeight !== "auto" && !maxHeight.endsWith("%")) {
      const px = parseFloat(maxHeight);
      if (Number.isFinite(px) && px > 0) {
        return Math.max(
          0,
          el.getBoundingClientRect().bottom - host.getBoundingClientRect().top
        );
      }
    }
    el = el.parentElement;
  }
  return null;
}
